import WithAuth from "../../hoc/WithAuth";
import { useParams } from "react-router-dom";
import { useUserDetail } from "../../api/users";
import { Icons } from "../../assets/images/icons";
import { useEffect, useState } from "react";
import { Loader, User } from "lucide-react";
import { InfoCard } from "../../components/cards/info-card";
import { StatusBadge } from "../../components/shared/status-badge";

const UserDetailPage = () => {
  const { id } = useParams();

  const [userData, setUserData] = useState<any>(null);

  const { data: user, isLoading } = useUserDetail(id || "");

  const {
    createdBy,
    createdAt,
    updatedBy,
    updatedAt,
    organization,
    fullName,
    phoneNo,
    email,
    role,
    username,
    isActive,
  } = user?.data?.data || {};

  useEffect(() => {
    if (user?.data?.data) {
      setUserData(user.data.data);
    }
  }, [user]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (!userData) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <h2 className="text-xl font-semibold text-gray-600">User not found</h2>
      </div>
    );
  }

  const metaData = [
    {
      title: "Created By",
      value: createdBy,
      icon: User,
    },
    {
      title: "Created At",
      value: createdAt,
      icon: Icons.calendar03Icon,
    },
    {
      title: "Updated By",
      value: updatedBy || "N/A",
      icon: User,
    },
    {
      title: "Updated At",
      value: updatedAt || "N/A",
      icon: Icons.arrowReloadIcon,
    },
  ];

  const userInfo = [
    {
      title: "Company Name",
      value: organization,
    },
    {
      title: "Full Name",
      value: fullName,
    },
    {
      title: "Phone Number",
      value: phoneNo,
    },
    {
      title: "Email",
      value: email,
    },
    {
      title: "Role",
      value: role,
    },
    {
      title: "Username",
      value: username,
    },
    {
      title: "Status",
      value: <StatusBadge value={isActive === "1" ? "Active" : "Inactive"} />,
    },
  ];

  return (
    <div
      className="bg-white px-4 md:px-8 py-8 h-screen"
      style={{ fontFamily: "Poppins" }}
    >
      {/** Combined Information Section */}
      <div className="bg-white border border-[#E6EEF6] rounded-2xl p-6 w-full">
        {/** System Information */}
        <h2 className="text-base font-medium text-black mb-6">
          System Information
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-6 mb-4">
          {metaData.map((meta) => (
            <InfoCard title={meta.title} value={meta.value} icon={meta?.icon} />
          ))}
        </div>
      </div>

      {/** User Information Section */}
      <div className="bg-white border border-[#E6EEF6] rounded-2xl p-6 w-full mt-3">
        {/** User Information */}
        <h2 className="text-base font-medium text-black mb-6">User Profile</h2>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-y-4 gap-x-6 mb-4">
          {userInfo.map((product) => (
            <InfoCard title={product.title} value={product.value} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default WithAuth(UserDetailPage);
